import { ZeroProvider } from "@rocicorp/zero/react"
import { useQuery } from "@tanstack/react-query"
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client"
import { RouterProvider } from "@tanstack/react-router"
import * as React from "react"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Toaster } from "sonner"

import * as Auth from "./lib/auth.ts"
import * as Query from "./lib/query.ts"
import { router } from "./lib/router.ts"
import { rpc } from "./lib/rpc.ts"
import * as Zero from "./lib/zero.ts"

import "./index.css"

const rootElement = document.getElementById("root")
if (rootElement && !rootElement.innerHTML)
  createRoot(rootElement).render(
    <StrictMode>
      <PersistQueryClientProvider
        client={Query.client}
        persistOptions={{ persister: Query.persister }}
      >
        <App />
      </PersistQueryClientProvider>
    </StrictMode>,
  )

function App() {
  const { data: authData } = Auth.useAuthData({ refetchOnMount: "always" })
  const zero = React.useMemo(() => Zero.create(authData), [authData])
  useQuery({
    enabled: Boolean(authData),
    // TODO: Switch to durable object
    async queryFn(_context) {
      return await rpc.me.ping.$get().then((res) => res.json())
    },
    queryKey: ["me.ping"],
    refetchInterval: 30_000,
    retry: false,
  })
  return (
    <>
      {/* TODO: Switch to ZeroContext https://github.com/rocicorp/mono/pull/5102 */}
      <ZeroProvider zero={zero}>
        <RouterProvider context={{ authData, zero }} router={router} />
      </ZeroProvider>
      {/* TODO: Convert to <Banner /> https://primer.style/product/components/banner/*/}
      <Toaster
        icons={{
          success: <OcticonCheckCircle16 className="text-green-3" />,
          info: <OcticonInfo16 className="text-blue-4" />,
          warning: <OcticonAlert16 className="text-yellow-3" />,
          error: <OcticonStop16 className="text-red-4" />,
        }}
        toastOptions={{
          classNames: {
            description: "!text-neutral-10",
            title: "!text-neutral-12",
            toast: "!bg-inset !border-default",
          },
        }}
      />
    </>
  )
}
